import { render, staticRenderFns } from "./P030.vue?vue&type=template&id=f860f18a"
import script from "./P030.vue?vue&type=script&lang=js"
export * from "./P030.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports